import UserRequestModelBase from '../_generated/modelBases/user-request-model-base';

export default class UserRequestModel extends UserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
